export { default } from './EmailCta'
